module.exports = __webpack_public_path__ + "static/img/18-迅龙创威.73c85290.png";